(() => {
  const buttons = '.rd-button,.btn,.btn--tertiary,.alpe-bundle__product-cta,.alpe-bundle__summary-cta,.alpe-bundle-final-cta__button,.shopify-payment-button__button--unbranded';
  const excluded = 'svg,script,style,.rd-arrow,.rd-menu__desktop-arrow,.rd-optical-label,.visually-hidden,.sr-only';
  const align = root => {
    if (!root.isConnected) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const labels = [];
    while (walker.nextNode()) {
      const node = walker.currentNode;
      const parent = node.parentElement;
      if (node.textContent.trim() && parent?.closest(buttons) && !parent.closest(excluded)) labels.push(node);
    }
    labels.forEach(node => {
      const label = document.createElement('span');
      label.className = 'rd-optical-label';
      node.replaceWith(label);
      label.append(node);
    });
  };
  document.querySelectorAll(buttons).forEach(align);
  const pending = new Set();
  let frame;
  const observer = new MutationObserver(records => {
    records.forEach(record => record.addedNodes.forEach(node => {
      if (node.nodeType === Node.ELEMENT_NODE && !node.closest(excluded)) pending.add(node);
      else if (node.nodeType === Node.TEXT_NODE && node.parentElement?.closest(buttons) && !node.parentElement.closest(excluded)) pending.add(node.parentElement);
    }));
    if (!pending.size || frame) return;
    frame = requestAnimationFrame(() => {
      frame = null;
      pending.forEach(root => {
        if (root.closest(buttons)) align(root);
        else root.querySelectorAll(buttons).forEach(align);
      });
      pending.clear();
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
